import React, { useState, useEffect } from "react";

import { Grid, Dimmer, Loader, Image, Button } from "semantic-ui-react";

import "./DesarrolladoPor.scss";

import { TableIntegrantes } from "../../components";

import { Link } from "react-router-dom";

import imagen from "../../images/imagenEquipo (1).png";

const proyectLeader = [
  {
    nombre: "Lic. Bruno Caseres",
    descripcion:
      "Licenciado en Sistemas. Ministerio de Salud de la Provincia de Jujuy",
    icon: "cogs",
  },
];

const developers = [
  {
    nombre: "José Luis Quispe",
    descripcion: "Estudiante avanzado de Ingeniería en Informática",
    icon: "keyboard outline",
  },
  {
    nombre: "Daiana Agustina Maraz",
    descripcion: "Analista Programador Universitario",
    icon: "keyboard outline",
  },
  {
    nombre: "Maximiliano Joaquín Carrillo",
    descripcion: "Analista Programador Universitario",
    icon: "keyboard outline",
  },
];

export function DesarrolladoPor() {
  const [imagenCargada, setImagenCargada] = useState(false);

  const cargaImagen = () => {
    setImagenCargada(true);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <>
      <Dimmer active={!imagenCargada} inverted>
        <Loader>Espere un momento</Loader>
      </Dimmer>

      <Grid
        className="gridPage"
        stackable
        style={{
          display: imagenCargada ? "flex" : "none",
        }}
      >
        <Grid.Row>
          <Grid.Column>
            <h2 className="tituloPage">
              INTEGRANTES DEL EQUIPO DE DESARROLLO WEB
            </h2>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row columns={2}>
          <Grid.Column>
            <h2 className="tituloEquipo">Líder de Proyecto:</h2>
            <TableIntegrantes integrantes={proyectLeader} />

            <h2 className="tituloEquipo">Desarrolladores:</h2>
            <TableIntegrantes integrantes={developers} />

            <div style={{ textAlign: "center", marginTop: "28px" }}>
              <Button className="buttonFormat" as={Link} to={"/"}>
                Volver al Inicio
              </Button>
            </div>
          </Grid.Column>

          <Grid.Column textAlign="center" verticalAlign="middle">
            <Image
              className="imagenEquipo"
              centered
              src={imagen}
              onLoad={cargaImagen}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
}
